(function () {
  "use strict";
  const $d = document;
  const CSV = (s) => {
    if (Array.isArray(s)) {
      return s.map(x=>{
        if (x == null) return "";
        if (typeof x === "string") return x;
        if (typeof x === "object") return x.handle ?? x.title ?? x.name ?? "";
        return String(x);
      }).map(x=>String(x).trim().toLowerCase()).filter(Boolean);
    }
    if (typeof s === "string") return s.split(/[\n,]+/).map(x=>x.trim().toLowerCase()).filter(Boolean);
    if (s == null) return [];
    return [String(s).trim().toLowerCase()].filter(Boolean);
  };
  const fmtMoney = (cents, fmt) => { try { if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents, fmt || "${{amount}}"); } catch(_){} return (cents / 100).toFixed(2); };
  const selAll = (s, root) => Array.prototype.slice.call((root || $d).querySelectorAll(s) || []);
  const cartPathRx = /\/cart\/?$/i;
  const getCartForm = () => {
    const forms = Array.prototype.slice.call($d.querySelectorAll('form[action]') || []);
    return forms.find((form) => {
      const action = form.getAttribute('action') || '';
      try {
        const url = new URL(action, window.location.origin);
        return cartPathRx.test(url.pathname);
      } catch {
        return cartPathRx.test(action);
      }
    });
  };
  const cartRoot = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };
  const isCheckoutHref = (href) => {
    if (!href) return false;
    try { const a=$d.createElement('a'); a.href=href; const p=((a.pathname||'')+(a.search||'')).toLowerCase(); return /(\/checkout(?:s)?)(?:\/|\?|$)/.test(p); }
    catch { return /(\/checkout(?:s)?)(?:\/|\?|$)/i.test(String(href)); }
  };
  const debounce = (fn, ms) => { let t=null; return function(){ if(t) clearTimeout(t); t=setTimeout(()=>fn.apply(this,arguments),ms); }; };
  function readConfig(){ const el=$d.getElementById('min-order-config'); if(el&&el.textContent){ try{ return JSON.parse(el.textContent); }catch(_){} } if(window.MIN_ORDER_CONFIG) return window.MIN_ORDER_CONFIG; return null; }

  const STATE = { ready:false, allowed:true, minCents:0, eligibleCents:0, anyEligible:false, snapshot:"", booted:false };
  window.MinOrderGuard = STATE;
  const isAllowedNow = () => (STATE.ready && STATE.allowed);

  let EVAL_LOCK = false;
  let EVAL_PENDING = false;

  function buildMessage(cfg, minCents, eligibleCents){
    const missing=Math.max(0,minCents-eligibleCents);
    const minFmt=fmtMoney(minCents,cfg.money_format);
    const missFmt=fmtMoney(missing,cfg.money_format);
    const tpl=String(cfg.msg||'').trim();
    if(!tpl) return `El pedido mínimo es ${minFmt}. Te faltan ${missFmt} para finalizar la compra.`;
    return tpl.replace(/{{\s*min\s*}}|{{\s*min_price\s*}}/g,minFmt).replace(/{{\s*faltante\s*}}|{{\s*missing\s*}}/g,missFmt);
  }
  function computeErrorText(){
    const cfg = readConfig() || {};
    return buildMessage(cfg, STATE.minCents, STATE.eligibleCents);
  }

  function ensureErrorContainers(){
    let pageErr = $d.getElementById('cart-errors');
    if (!pageErr) {
      const form=getCartForm();
      if(form){
        pageErr=$d.createElement('div');
        pageErr.id='cart-errors';
        pageErr.setAttribute('role','alert');
        pageErr.setAttribute('aria-live','polite');
        pageErr.setAttribute('aria-atomic','true');
        pageErr.style.cssText='margin:8px 0 0; color:#c62828; font-size:0.95rem;';
        form.prepend(pageErr);
      }
    }
    const drawerErr = $d.getElementById('cart-drawer-errors');
    if (drawerErr && drawerErr.parentNode) drawerErr.parentNode.removeChild(drawerErr);
  }
  function showMessage(text){
    const a=$d.getElementById('cart-errors');
    const safe=(text&&String(text).trim())?text:'\u00A0';
    if(a && a.textContent!==safe) a.textContent=safe;
  }

  let __minorder_style=false;
  function nudgeAndAnnounce(){
    ensureErrorContainers();
    showMessage(computeErrorText());
    if(!__minorder_style){
      const st=$d.createElement('style');
      st.textContent=`@keyframes minorder-shake{20%{transform:translateX(-4px)}40%{transform:translateX(4px)}60%{transform:translateX(-3px)}80%{transform:translateX(3px)}100%{transform:none}}#cart-errors{will-change:transform}.minorder-shake{animation:minorder-shake .35s ease}`;
      $d.head.appendChild(st);
      __minorder_style=true;
    }
    const box=$d.getElementById('cart-errors');
    if(box){ box.classList.remove('minorder-shake'); void box.offsetWidth; box.classList.add('minorder-shake'); }
    try{ navigator.vibrate && navigator.vibrate(20);}catch(_){}
  }

  function setButtonsState(_allowed){
    const btnSel = [
      'form[action$="/cart"] [name="checkout"]',
      'form[action$="/cart/"] [name="checkout"]',
      'cart-drawer form [name="checkout"]',
      '.cart-drawer form [name="checkout"]',
      '[data-checkout-button]',
      '[data-checkout]',
      'button[data-action="checkout"]',
      'form[action*="/checkout"] button',
      'form[action*="/checkout"] [type="submit"]',
      '.checkout'
    ].join(',');
    const disabledText = computeErrorText();
    const bind = (el)=>{
      if(el.__min_click_bound) return;
      if(!el.getAttribute('name')) el.setAttribute('name','checkout');
      const block = (e)=>{ if(!isAllowedNow()){ e.preventDefault(); e.stopPropagation(); nudgeAndAnnounce(); } };
      ['pointerdown','mousedown','touchstart','click','keydown'].forEach(ev=>{
        el.addEventListener(ev,(e)=>{ if(ev==='keydown'){ const k=e.key||e.code; if(k!=='Enter'&&k!==' '&&k!=='Space') return; } block(e); }, true);
      });
      el.__min_click_bound=true;
    };
    selAll(btnSel).forEach(bind);
    selAll(btnSel).forEach(el=>{
      const tag = (el.tagName||'').toLowerCase();
      const isButtonLike = tag==='button' || (tag==='input' && (el.type==='submit' || el.type==='button'));
      const isAnchor = tag==='a' && isCheckoutHref(el.getAttribute('href'));
      if(el.__min_orig_text==null){
        el.__min_orig_text = isButtonLike ? (el.textContent?.trim() || el.value || '') : (el.textContent?.trim() || '');
      }
      if(_allowed){
        if(isButtonLike && el.disabled){ el.disabled = false; }
        if(isAnchor){
          if(el.getAttribute('aria-disabled')!=='false') el.setAttribute('aria-disabled','false');
          if(el.style.pointerEvents==='none') el.style.pointerEvents='';
          if(el.style.opacity) el.style.opacity='';
          if (el.getAttribute('tabindex')==='-1') el.removeAttribute('tabindex');
          if (el.hasAttribute('inert')) el.removeAttribute('inert');
        }
        const orig = el.__min_orig_text || '';
        if(tag==='input'){
          if((el.type==='submit' || el.type==='button') && el.value !== orig){ el.value = orig; }
        } else {
          if(el.textContent !== (orig || el.textContent || '')) el.textContent = (orig || el.textContent || '');
        }
        if(el.hasAttribute('title')) el.removeAttribute('title');
      }else{
        if(isButtonLike && !el.disabled){ el.disabled = true; }
        if(isAnchor){
          if(el.getAttribute('aria-disabled')!=='true') el.setAttribute('aria-disabled','true');
          if(el.style.pointerEvents!=='none') el.style.pointerEvents='none';
          if(el.style.opacity!=='0.6') el.style.opacity='0.6';
          if (el.getAttribute('tabindex')!=='-1') el.setAttribute('tabindex','-1');
          if (!el.hasAttribute('inert')) el.setAttribute('inert','');
        }
        if(tag==='input'){
          if((el.type==='submit' || el.type==='button') && el.value !== disabledText){ el.value = disabledText; }
        } else {
          if(el.textContent !== disabledText){ el.textContent = disabledText; }
        }
        if(el.getAttribute('title')!==disabledText) el.setAttribute('title', disabledText);
      }
    });
    selAll('.shopify-payment-button').forEach(w=>{
      const want = _allowed ? '' : 'none';
      if(w.style.display !== want) w.style.display = want;
    });
  }

  function installGlobalGuard(){
    if ($d.__min_global_guard_installed) return;
    $d.__min_global_guard_installed = true;
    const RX_CHECKOUT=/(^|\/)checkout(?:s)?(?:\/|\?|$)/i, RX_CART=/(^|\/)cart(?:\/|\?|$)/i;
    const notAllowed=()=>!isAllowedNow();
    $d.addEventListener('submit', function(e){
      try{
        const f=e.target; if(!f||f.nodeType!==1) return;
        const action=(f.getAttribute('action')||'').toLowerCase();
        const sub=e.submitter; const formaction=(sub&&sub.getAttribute&&(sub.getAttribute('formaction')||'').toLowerCase())||'';
        const isCheckout=RX_CHECKOUT.test(action)||RX_CHECKOUT.test(formaction);
        const isCartCheckout=RX_CART.test(action) && (sub?.getAttribute?.('name')==='checkout');
        if (notAllowed() && (isCheckout || isCartCheckout)){ e.preventDefault(); e.stopPropagation(); nudgeAndAnnounce(); }
      }catch(_){}
    }, true);
    const intercept=(e)=>{
      const path=e.composedPath?.()||[];
      const btn=path.find(n=>n&&n.getAttribute&&( RX_CHECKOUT.test(n.getAttribute('formaction')||'') || n.getAttribute('data-checkout-button')!=null || n.getAttribute('data-checkout')!=null || n.getAttribute('data-action')==='checkout' ));
      if(btn && notAllowed()){ e.preventDefault(); e.stopPropagation(); nudgeAndAnnounce(); return; }
      const a=path.find(n=>n&&n.tagName==='A' && RX_CHECKOUT.test(n.getAttribute('href')||'')); 
      if(a && notAllowed()){ e.preventDefault(); e.stopPropagation(); nudgeAndAnnounce(); return; }
    };
    ['pointerdown','mousedown','touchstart','click','keydown'].forEach(ev=>{
      $d.addEventListener(ev,(e)=>{ if(ev==='keydown'){ const k=e.key||e.code; if(k!=='Enter'&&k!==' '&&k!=='Space') return; } intercept(e); }, true);
    });
    try{
      const ORIG_SUBMIT = HTMLFormElement.prototype.submit;
      HTMLFormElement.prototype.submit = function(...args){
        try{
          const action = String((this.getAttribute?.('action') || this.action || '')).toLowerCase();
          if (!isAllowedNow() && (/(^|\/)checkout(?:s)?(?:\/|\?|$)/i.test(action) || /(\/)cart(\/|\?|$)/i.test(action))) { nudgeAndAnnounce(); return; }
        }catch(_){}
        return ORIG_SUBMIT.apply(this,args);
      };
    }catch(_){}
    try{
      const L=Location.prototype, a=L.assign, r=L.replace;
      const desc=Object.getOwnPropertyDescriptor(L,'href');
      const shouldBlock=(url)=>!isAllowedNow() && /(\/)checkout(?:s)?(\/|\?|$)/i.test(String(url||''));
      if(a) L.assign=function(u){ if(shouldBlock(u)){ nudgeAndAnnounce(); return; } return a.call(this,u); };
      if(r) L.replace=function(u){ if(shouldBlock(u)){ nudgeAndAnnounce(); return; } return r.call(this,u); };
      if(desc&&desc.set&&desc.get){
        Object.defineProperty(L,'href',{configurable:true, enumerable:desc.enumerable,
          get(){ return desc.get.call(this); },
          set(v){ if(shouldBlock(v)){ nudgeAndAnnounce(); return; } return desc.set.call(this,v); }
        });
      }
    }catch(_){}
    try{
      const p=history.pushState.bind(history), rp=history.replaceState.bind(history);
      const shouldBlock=(u)=>!isAllowedNow() && u && /(^|\/)checkout(?:s)?(?:\/|\?|$)/i.test(String(u));
      history.pushState=function(s,t,u){ if(shouldBlock(u)){ nudgeAndAnnounce(); return; } return p(s,t,u); };
      history.replaceState=function(s,t,u){ if(shouldBlock(u)){ nudgeAndAnnounce(); return; } return rp(s,t,u); };
    }catch(_){}
  }

  function lineEligible(line, exH, exT){ const h=String(line.handle||'').toLowerCase(); const t=String(line.product_type||'').toLowerCase(); if(exH.has(h))return false; if(exT.has(t))return false; return true; }
  async function getCart(){ const url=`${cartRoot()}cart.js?t=${Date.now()}`; const r=await fetch(url,{credentials:'same-origin',cache:'no-store'}); if(!r.ok) throw new Error('cart fetch failed: '+r.status); return r.json(); }

  const evaluateCore = async () => {
    const cfg = readConfig();
    if (!STATE.booted) setButtonsState(false);
    STATE.ready=false;
    if(!cfg){
      STATE.allowed=true; STATE.ready=true;
      $d.documentElement.setAttribute('data-min-allowed','1');
      showMessage('');
      setButtonsState(true);
      STATE.booted = true;
      STATE.snapshot = JSON.stringify({min:STATE.minCents, elig:STATE.eligibleCents, any:false});
      return;
    }
    const minCents=Math.max(0, Math.round((cfg.amount||0)*100)); STATE.minCents=minCents;
    const cxTags=new Set((cfg.customer_tags||[]).map(t=>String(t).toLowerCase()));
    const exTags=new Set(CSV(cfg.exempt_tags));
    for(const t of cxTags){
      if(exTags.has(t)){
        STATE.allowed=true; STATE.ready=true;
        $d.documentElement.setAttribute('data-min-allowed','1');
        showMessage('');
        setButtonsState(true);
        STATE.booted = true;
        STATE.snapshot = JSON.stringify({min:STATE.minCents, elig:STATE.eligibleCents, any:false});
        return;
      }
    }
    if(!minCents){
      STATE.allowed=true; STATE.ready=true;
      $d.documentElement.setAttribute('data-min-allowed','1');
      showMessage('');
      setButtonsState(true);
      STATE.booted = true;
      STATE.snapshot = JSON.stringify({min:STATE.minCents, elig:STATE.eligibleCents, any:false});
      return;
    }
    let cart;
    try{ cart=await getCart(); }
    catch(_){
      STATE.allowed=true; STATE.ready=true;
      $d.documentElement.setAttribute('data-min-allowed','1');
      showMessage('');
      setButtonsState(true);
      STATE.booted = true;
      STATE.snapshot = JSON.stringify({min:STATE.minCents, elig:STATE.eligibleCents, any:false});
      return;
    }
    if(!cart.items||cart.items.length===0){
      STATE.allowed=true; STATE.ready=true; STATE.eligibleCents=0; STATE.anyEligible=false;
      $d.documentElement.setAttribute('data-min-allowed','1');
      showMessage('');
      setButtonsState(true);
      STATE.booted = true;
      STATE.snapshot = JSON.stringify({min:STATE.minCents, elig:STATE.eligibleCents, any:false});
      return;
    }
    const cfgExH = [...CSV(cfg.excluded_handles),...CSV(cfg.excluded_product_handles),...CSV(cfg.excluded_collection_handles)];
    const exH = new Set(cfgExH);
    const exT = new Set(CSV(cfg.excluded_types));

    let anyIncluded=false;
    let totalCents=0;
    (cart.items||[]).forEach(i=>{ totalCents += (i.final_line_price||0); if(lineEligible(i,exH,exT)) anyIncluded=true; });

    const eligible = anyIncluded ? totalCents : 0;

    STATE.eligibleCents=eligible; STATE.anyEligible=anyIncluded;

    const allowed = !anyIncluded || (eligible >= minCents);

    STATE.allowed=allowed; STATE.ready=true;
    const snap = JSON.stringify({min:minCents, elig:eligible, any:anyIncluded});
    if (snap !== STATE.snapshot){
      ensureErrorContainers();
      const msg = allowed ? '' : computeErrorText();
      showMessage(msg);
      $d.documentElement.setAttribute('data-min-allowed', allowed ? '1' : '0');
      setButtonsState(allowed);
      STATE.snapshot = snap;
    }
    STATE.booted = true;
  };

  const evaluate = debounce(async function(){
    if (EVAL_LOCK) { EVAL_PENDING = true; return; }
    EVAL_LOCK = true;
    try { await evaluateCore(); }
    finally {
      EVAL_LOCK = false;
      if (EVAL_PENDING) {
        EVAL_PENDING = false;
        await evaluateCore();
      }
    }
  }, 80);

  function wireThemeEvents(){
    const reeval=()=>evaluate();
    $d.addEventListener('cart:updated', reeval);
    $d.addEventListener('cart:change',  reeval);
    $d.addEventListener('cart:open',    ()=>{ ensureErrorContainers(); evaluate(); setTimeout(evaluate,150); });
    $d.addEventListener('change',(e)=>{ const t=e.target; if(!t) return; if(t.name==='updates[]'||t.matches('input.qty, input.quantity__input, .qty-input__input')){ evaluate(); setTimeout(evaluate,120); } });
    $d.addEventListener('click',(e)=>{ const el=e.target; if(!el) return; if(el.closest?.('[data-quantity-button]')||el.closest?.('button[name="remove"]')||el.matches?.('quantity-input button, .qty-input__btn')||el.closest?.('.quantity__button')){ evaluate(); setTimeout(evaluate,120); } });
    const drawer=$d.querySelector('cart-drawer, .cart-drawer');
    if(drawer){
      const cbDebounced = debounce(()=>evaluate(), 80);
      const moTree=new MutationObserver((records)=>{
        const allInsidePayBtn = records.every(r=>{
          const t=r.target;
          return t && t.closest && t.closest('.shopify-payment-button');
        });
        if(!allInsidePayBtn) cbDebounced();
      });
      moTree.observe(drawer,{childList:true,subtree:true});
      const moAttr=new MutationObserver(debounce(evaluate,80));
      moAttr.observe(drawer,{attributes:true,attributeFilter:['open']});
      window.addEventListener('pagehide',()=>{ try{ moTree.disconnect(); moAttr.disconnect(); }catch(_){ } },{once:true});
    }
    const bodMo=new MutationObserver(debounce(()=>{ ensureErrorContainers(); },60));
    bodMo.observe($d.body||$d.documentElement,{childList:true,subtree:true});
    window.addEventListener('pagehide',()=>{ try{ bodMo.disconnect(); }catch(_){ } },{once:true});

    (function addCartPageObservers(){
      const reevalDebounced = debounce(()=>evaluate(), 80);

      ['shopify:section:load','shopify:section:unload','shopify:section:select',
       'shopify:section:deselect','shopify:section:reorder','shopify:section:reload'].forEach(ev=>{
         window.addEventListener(ev, reevalDebounced);
      });

      const attachFormObserver = (form) => {
        if (!form || form.__minorder_observed) return;
        const moCart = new MutationObserver(reevalDebounced);
        moCart.observe(form, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled','aria-disabled','href','class','style']
        });
        form.__minorder_observed = true;
        window.addEventListener('pagehide',()=>{ try{ moCart.disconnect(); }catch(_){} }, {once:true});
      };

      const cartFormInit = getCartForm();
      if (cartFormInit) attachFormObserver(cartFormInit);

      const moBodyCart = new MutationObserver(debounce(()=>{
        const cf = getCartForm();
        if (cf) attachFormObserver(cf);
        reevalDebounced();
      }, 120));
      moBodyCart.observe($d.body || $d.documentElement, {childList:true,subtree:true});
      window.addEventListener('pagehide',()=>{ try{ moBodyCart.disconnect(); }catch(_){ } },{once:true});
    })();
  }

  function ready(fn){ if($d.readyState==='loading') $d.addEventListener('DOMContentLoaded',fn,{once:true}); else fn(); }
  ready(()=>{ STATE.ready=false; $d.documentElement.setAttribute('data-min-allowed','0'); installGlobalGuard(); evaluate(); wireThemeEvents(); });
})();